<template>
  <div class="stack-effect-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>ΔP = C · h · (1/To - 1/Ti)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Vertical Shaft (Stack) -->
          <rect x="170" y="40" width="60" height="180" fill="rgba(255,255,255,0.05)" stroke="#888" />
          
          <!-- Heat source at bottom -->
          <g v-if="tempDiff > 10" transform="translate(185, 200)">
             <path d="M 0,0 Q 15,-30 30,0 Z" fill="#ff4757" opacity="0.6">
                <animate attributeName="opacity" values="0.4;1;0.4" dur="0.8s" repeatCount="indefinite" />
             </path>
          </g>

          <!-- Airflow arrows (Rising hot air) -->
          <g v-for="n in 5" :key="n" :transform="`translate(190, ${220 - n*40})`">
             <path d="M 0,0 L 20,0 L 10,-20 Z" fill="#ff4757" :opacity="tempDiff/100">
                <animateTransform attributeName="transform" type="translate" :from="`0,${n*40}`" :to="`0,${n*40 - 240}`" :dur="`${(100-tempDiff)/10 + 1}s`" repeatCount="indefinite" />
             </path>
          </g>

          <!-- Cold air entry at bottom -->
          <path d="M 120,210 L 160,210" stroke="#00d2ff" stroke-width="4" marker-end="url(#arrow)" />
          <text x="100" y="225" fill="#00d2ff" font-size="8">冷空气补给</text>

          <!-- Hot air exit at top -->
          <path d="M 230,50 L 270,50" stroke="#ff4757" stroke-width="4" marker-end="url(#arrow)" />
          <text x="240" y="45" fill="#ff4757" font-size="8">热风排出</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>内外温差 ΔT: {{ tempDiff }} °C</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节热源强度</label>
             <el-slider v-model="tempDiff" :min="0" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>烟囱效应是指空气由于密度差产生的热浮力。室内较热的空气密度较小，会沿垂直通道上升，并在顶部排出，同时在底部吸入较冷的室外空气。温差越大、通道越高，这种抽力就越强。它是古代建筑自然通风、烟囱排烟以及高层建筑火灾中烟气快速蔓延的物理根源。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StackEffectViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      tempDiff: 40
    }
  }
}
</script>

<style scoped lang="scss">
.stack-effect-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 71, 87, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
